import store from "../../../store";

/**
 * Verificar si estamos en presencia de cierto Marketing Channel en el CID
 * de la URL para disparar un pixel
 * (o una callback en general)
 * @param cid Array | String
 * @param cb function
 */
export const matchesTCode = (cid, cb) => {
  let current_cid = store.getters.getTcode();
  // El cid puede ser string o array
  if (typeof cid === "string") {
    cid = [cid];
  }

  for (const c of cid) {
    if (
      current_cid &&
      (current_cid + "").toLowerCase().includes(c.toLowerCase())
    ) {
      if (cb && typeof cb == "function") {
        return cb();
      }
    }
  }
};

export const typologyAdobe = campaign => {
  const campaigns = {
    REFERIR_TC: "campana tarjetas",
    REFERIR_JUBILADO: "campana jubilado",
    REFERIR_NOMINA: "campana sueldo"
  };

  return campaigns[campaign] || "";
};

export const offerAdobe = () => {
  let aux = "";
  const premios = store.getters.getPaso3().premios;
  const seleccion = store.getters.getPaso3().seleccion;

  for (const premio of premios) {
    if (premio.codigoPremio === seleccion) {
      aux = premio.tipoPremio || "";
    }
  }

  const prizes = {
    C: "cashback",
    B: "millas"
  };

  return prizes[aux] || "";
};
